import { render } from "./userTable.vue?vue&type=template&id=18d96ec4"
import script from "./userTable.vue?vue&type=script&lang=js"
export * from "./userTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__